/** Severidades aceitas pelo p-tag do PrimeNG **/
export type TagSeverity = 'success' | 'info' | 'warn' | 'danger' | 'secondary' | 'contrast';

export interface StatusMeta {
  labelKey: string;
  severity: TagSeverity;
  icon: string;
  styleClass: string;
}

export interface PriorityMeta {
  labelKey: string;
  cssClass: string;
  icon: string;
}

export const SERVICE_ORDER_STATUS: Record<string, StatusMeta> = {
  OPEN: {
    labelKey: 'service-order.status-label-open',
    severity: 'info',
    icon: 'pi pi-inbox',
    styleClass: '',
  },
  IN_PROGRESS: {
    labelKey: 'service-order.status-label-in-progress',
    severity: 'warn',
    icon: 'pi pi-clock',
    styleClass: '',
  },
  CLOSED: {
    labelKey: 'service-order.status-label-closed',
    severity: 'success',
    icon: 'pi pi-check-circle',
    styleClass: '',
  },
  CLOSED_WITH_ISSUES: {
    // p-tag não tem severity laranja: reaproveita danger e re-tinta via styleClass
    labelKey: 'service-order.status-label-closed_with_issues',
    severity: 'danger',
    icon: 'pi pi-exclamation-triangle',
    styleClass: 'tag-closed-issues',
  },
  DELETED: {
    labelKey: 'service-order.status-label-deleted',
    severity: 'secondary',
    icon: 'pi pi-trash',
    styleClass: '',
  },
};

export const SERVICE_ORDER_PRIORITY: Record<string, PriorityMeta> = {
  LOW: {
    labelKey: 'service-order.priority-label-low',
    cssClass: 'prio-pill--low',
    icon: 'pi pi-angle-down',
  },
  MEDIUM: {
    labelKey: 'service-order.priority-label-medium',
    cssClass: 'prio-pill--medium',
    icon: 'pi pi-minus',
  },
  HIGH: {
    labelKey: 'service-order.priority-label-high',
    cssClass: 'prio-pill--high',
    icon: 'pi pi-angle-double-up',
  },
};

/** DELETED não é selecionável: só aparece em dado que vem da API **/
export const STATUS_OPTIONS = ['OPEN', 'IN_PROGRESS', 'CLOSED', 'CLOSED_WITH_ISSUES'];

/** Na edição a pendência é um checkbox ao lado dos detalhes, não um status à parte **/
export const EDIT_STATUS_OPTIONS = ['OPEN', 'IN_PROGRESS', 'CLOSED'];

export const PRIORITY_OPTIONS = ['LOW', 'MEDIUM', 'HIGH'];

/** Status em que a OS não aceita mais edição/transição **/
export const CLOSED_STATUSES = ['CLOSED', 'CLOSED_WITH_ISSUES', 'DELETED'];

export function statusMeta(status: string | null): StatusMeta {
  return (status && SERVICE_ORDER_STATUS[status]) || {
    labelKey: status ?? '',
    severity: 'secondary',
    icon: 'pi pi-question-circle',
    styleClass: '',
  };
}

export function priorityMeta(priority: string | null): PriorityMeta {
  return (priority && SERVICE_ORDER_PRIORITY[priority]) || {
    labelKey: priority ?? '',
    cssClass: 'prio-pill--low',
    icon: 'pi pi-minus',
  };
}

export function isClosedStatus(status: string | null): boolean {
  return !!status && CLOSED_STATUSES.includes(status);
}

export interface SelectOption {
  value: string;
  label: string;
}

/**
 * Monta as opções de select já traduzidas. O template #selectedItem do p-select só é
 * renderizado quando o label do option resolve, então passar `{ value, labelKey }` e
 * traduzir no template deixava o campo em branco: o label precisa vir pronto.
 **/
export function buildSelectOptions(
  values: string[],
  meta: (value: string) => { labelKey: string },
  translateFn: (key: string) => string,
): SelectOption[] {
  return values.map((value) => ({ value, label: translateFn(meta(value).labelKey) }));
}
